<template>
  <div>
    <label class="form-control-label">{{ label }}</label>

    <validation-provider v-slot="{ errors }" :name="label" :rules="rules">
      <b-select v-model="model" @change="$emit('change')">
        <option v-for="option in options" :value="option.value">{{
          option.text
        }}</option>
      </b-select>

      <slot name="error">
        <div v-if="errors[0]" class="invalid-feedback" style="display: block">
          {{ errors[0] }}
        </div>
      </slot>
    </validation-provider>
  </div>
</template>

<script>
export default {
  name: "m-select",
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  props: {
    rules: {
      type: String,
      required: false,
    },

    label: {
      type: String,
      required: false,
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    options: {
      type: [Array],
      required: true,
    },
  },
};
</script>
